<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import type { ImportResponseType } from '../../shared/ColumnSelectPro/currentImport';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import { ImportApi } from './ImportApi';
    import { api } from '../../../stores/api';
    import GeocodingStatus from './GeocodingStatus.svelte';
    import { debug } from '../../../stores/store';
    import { Import } from './Import';
    import IconWarning from '../../shared/Icons/IconWarning.svelte';
    import IconError from '../../shared/Icons/IconError.svelte';
    import { Umami } from '../../utilities/Umami';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    export let _import: ImportResponseType;
    export let showHeader: boolean = false;
    export let error: string = '';
    export let onUpdateOne: () => void;

    // type JobStatusType = 'ok' | 'geocoding' | '---';
    let progress: number = 0;
    let __import: Import;

    // function getStatus(): JobStatusType {
    //     if (_import?.jobs_created && _import.jobs_created===true) return 'ok';
    //     if (typeof _import?.jobs_created !== 'undefined' && _import.jobs_created===false) return 'geocoding';
    //     return '---';
    // }

    function removeOne() {
        // wyłączona ikona nie blokuje zdarzenia (pointer-events działa tylko w przeglądarce),
        // a kasowanie importu backend i tak odrzuca 403 read_only
        if (!get(canWrite)) return;
        error = '';
        if (_import) {
            const importId = __import.getId();
            ImportApi.remove(get(api), importId)
                .then(() => {
                    _import = null;
                    onUpdateOne();
                    Umami.event('import_delete', { import_id: importId });
                })
                .catch(e => {
                    error = 'Failed to delete this file.'; // TODO: Co ma zrobić user?
                    Umami.error('import_delete', e, { import_id: importId });
                });
        }
    }

    __import = new Import(_import);
</script>

{#if showHeader}
    <div class="list-element import-element list-element-header">
        <div class="uploaded">{$_('Uploaded')}</div>
        <div class="filename">{$_('File name')}</div>
        <div class="status">{$_('Status')}</div>
        <div class="remove">{$_('Remove')}</div>
    </div>
{/if}

{#if _import}
    <div class="list-element import-element list-element-data">
        <div class="uploaded">{(_import?.uploaded && _import.uploaded) || '---'}</div>
        <div class="filename">
            {#if $debug}
                <span>#{_import?.id}&nbsp;</span>
            {/if}
            {(_import?.filename && _import.filename) || '---'}
        </div>
        <div class="status">
            {#if _import.error !== null}
                <span><IconError scale={0.7} title={$_('An error occurred during import.')} /></span>
            {:else if __import.isCompleted()}
                <span>{$_('OK')}</span>
            {:else if __import.inProgress()}
                <GeocodingStatus inProgress={$_('Geocoding')} onDone={$_('OK')} bind:_import />
            {:else}
                <span>---</span>
            {/if}
        </div>
        <div class="remove">
            <IconRemove
                scale={0.7}
                disabled={!$canWrite}
                hover={$canWrite ? $_('Remove') : $_(writeDisabledTooltip)}
                on:click={removeOne}
            />
        </div>
    </div>
{/if}

<style>
    .import-element {
        grid-template-columns: 150px 1fr 90px 50px;
        grid-template-rows: var(--medium-row-height);
        grid-template-areas: 'uploaded filename status remove';
    }

    /*.list-element-data {*/
    /*    border-top: 1px solid #4444;*/
    /*}*/
    /*.list-element-data:last-of-type {*/
    /*    border-bottom: 1px solid #4444;*/
    /*}*/

    /*.list-element-header {*/
    /*    align-items: end;*/
    /*}*/

    /*.list-element-header > div {*/
    /*    height: 20px;*/
    /*    color: #0005;*/
    /*}*/

    .import-element.list-element-header > div,
    .import-element.list-element-data > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        /*justify-content: center;*/
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .import-element .filename {
        grid-area: filename;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .import-element .status {
        grid-area: status;
        justify-content: center;
    }

    .import-element .remove {
        grid-area: remove;
        justify-content: center;
    }

    .import-element .uploaded {
        grid-area: uploaded;
        justify-content: center;
    }
</style>
